import { useEffect, useLayoutEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const history = useHistory();

  const scrollToTop = () => {
    // Force scroll to top using multiple methods
    window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    
    // Direct DOM manipulation for maximum compatibility
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
      document.documentElement.scrollLeft = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
      document.body.scrollLeft = 0;
    }
    
    // Handle any scrollable containers
    const scrollableElements = document.querySelectorAll('[data-scroll-container]');
    scrollableElements.forEach(el => {
      el.scrollTop = 0;
      el.scrollLeft = 0;
    });
  };

  // Use useLayoutEffect for immediate scroll before paint
  useLayoutEffect(() => {
    scrollToTop();
    
    // Also scroll on next frame to catch any delayed renders
    requestAnimationFrame(scrollToTop);
  }, [pathname]);

  // Listen to history changes directly as backup
  useEffect(() => {
    const unlisten = history.listen(() => {
      // Scroll immediately on any history change
      scrollToTop();
      requestAnimationFrame(scrollToTop);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  // Also use useEffect as backup for async content
  useEffect(() => {
    // Immediate
    scrollToTop();
    
    // Multiple timeouts to catch different render phases
    const timeoutId1 = setTimeout(scrollToTop, 0);
    const timeoutId2 = setTimeout(scrollToTop, 10);
    const timeoutId3 = setTimeout(scrollToTop, 50);
    const timeoutId4 = setTimeout(scrollToTop, 100);
    const timeoutId5 = setTimeout(scrollToTop, 200);
    
    // On next frame
    requestAnimationFrame(scrollToTop);
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTop);
    });

    return () => {
      clearTimeout(timeoutId1);
      clearTimeout(timeoutId2);
      clearTimeout(timeoutId3);
      clearTimeout(timeoutId4);
      clearTimeout(timeoutId5);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;

